import React, { ReactNode } from "react";

import { faBuilding } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import { faHandshake } from "@fortawesome/pro-solid-svg-icons/faHandshake";
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { EntityType, EntityTypesSupportedByActivities } from "@mapmycustomers/shared/types/entity";

interface Props {
  children: ReactNode;
  entityType: EntityTypesSupportedByActivities;
  showIcon?: boolean;
}

const Label: React.FC<Props> = ({ children, entityType, showIcon }) => {
  return (
    <>
      {showIcon && entityType === EntityType.COMPANY && <FontAwesomeIcon icon={faBuilding} />}
      {showIcon && entityType === EntityType.PERSON && <FontAwesomeIcon icon={faUser} />}
      {showIcon && entityType === EntityType.DEAL && <FontAwesomeIcon icon={faHandshake} />}
      {children}
    </>
  );
};

export default Label;
